import React from 'react'
import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import { defaultModalStyle, defaultModalZIndex, minButtonWidth } from '../../const'
import { LoadingButton } from '@mui/lab'

interface Props {
  loading: boolean
  handleClose: () => void
  handleConfirm: () => void
  title: string
  body: React.ReactNode | string
}

const modalStyle = {
  ...defaultModalStyle,
  width: 420,
}

const ConfirmModal = (props: Props) => {
  const { title, loading, handleClose, handleConfirm } = props

  return (
    <Modal sx={defaultModalZIndex} open>
      <Box sx={modalStyle}>
        <Typography variant="h5" mb={3}>
          {title}
        </Typography>
        <Typography variant="body1">{props.body}</Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button variant="outlined" onClick={handleClose} sx={minButtonWidth}>
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={handleConfirm}
            sx={minButtonWidth}
          >
            Confirm
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  )
}

export default ConfirmModal
